import React, { useRef, useMemo, memo, useCallback } from "react";
import { Table, THead, TBody, TR, TD } from "../../../../components/lib/Table";
import Inline from "../../../../components/lib/Inline";
import Icon from "../../../../components/lib/Icon";
// @ts-ignore
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import DeleteUser from "./DeleteUser";
import EditUser from "./EditUser";
import Box from "../../../../components/lib/Box";
import Button from "../../../../components/lib/Button";
import { UniqueUser, keyType, useUploadUserContext } from "../context/UploadUserContext";

const textCenter = { textAlign: "center" };

const ViewFailedItem = ({ keyType }: { keyType: keyType }) => {
  const { response, addUserList, jsonDataLoading } = useUploadUserContext();

  const list = useMemo(() => response?.[keyType] || [], [response, keyType]);

  const userList = useMemo(() => {
    if (!list?.length) return [];

    return list?.map((user, index) => ({
      ...user,
      _uniqueId: `${user.email}-${user.username}_user_${index}_${keyType}`,
    }));
  }, [list, keyType]);

  if (!userList?.length) {
    return (
      <Box css={{ padding: "20px", textAlign: "center" }}>
        <p>No users found.</p>
      </Box>
    );
  }

  return (
    <>
      <VirtualList userList={userList} keyType={keyType} />
      <Box
        css={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          marginTop: "10px",
          width: "$full",
        }}
      >
        <Button
          color="brand"
          size="normal"
          loading={jsonDataLoading}
          onClick={() => addUserList(userList, keyType)}
        >
          Upload Users
        </Button>
      </Box>
    </>
  );
};

const VirtualList = memo(
  ({ userList, keyType }: { userList: UniqueUser[]; keyType: keyType }) => {
    const ref = useRef<HTMLDivElement>(null);

    const handleCountryIds = useCallback((countryIds: string[] | string) => {
      if (Array.isArray(countryIds)) {
        return countryIds.join(", ");
      }
      return countryIds;
    }, []);

    return (
      <div
        ref={ref}
        style={{
          minHeight: "100px",
          maxHeight: "300px",
          overflow: "auto",
          width: "100%",
        }}
      >
        <Table highlighted={false} css={{ width: "$full" }}>
          <THead
            css={{
              textTransform: "uppercase",
              position: "sticky",
              top: 0,
              backgroundColor: "#f8f9fa",
              zIndex: 10,
            }}
          >
            <TR>
              <TD css={textCenter}>#</TD>
              <TD css={textCenter}>First Name</TD>
              <TD css={textCenter}>Last Name</TD>
              <TD css={textCenter}>Email</TD>
              <TD css={textCenter}>Username</TD>
              <TD css={textCenter}>Client ID</TD>
              <TD css={textCenter}>Country ID</TD>
              <TD css={textCenter}>Release User</TD>
              <TD css={textCenter}>Release Password</TD>
              <TD css={textCenter}>Action</TD>
            </TR>
          </THead>
          <TBody css={{ width: "$full" }}>
            {userList?.length > 0 &&
              userList.map((user, index) => {
                console.log("user --", user);
                return (
                  <TR
                    key={user._uniqueId}
                    css={{
                      width: "$full",
                    }}
                  >
                    <TD css={textCenter}>{index + 1}</TD>
                    <TD css={textCenter}>{user.first_name}</TD>
                    <TD css={textCenter}>{user.last_name}</TD>
                    <TD css={textCenter}>{user.email}</TD>
                    <TD css={textCenter}>{user.username}</TD>
                    <TD css={textCenter}>{user.client_id}</TD>
                    <TD css={textCenter}>{handleCountryIds(user.country_id)}</TD>
                    <TD css={textCenter}>{user.release_user ? "True" : "False"}</TD>
                    <TD css={textCenter}>{user.release_password ? "True" : "False"}</TD>
                    <TD css={textCenter}>
                      <Inline css={{ gap: "10px", justifyContent: "center" }}>
                        <EditUser
                          user={user}
                          index={index}
                          userList={userList}
                          keyType={keyType}
                        />
                        <DeleteUser user={user} userList={userList} keyType={keyType} />
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id={`tooltip-${user._uniqueId}`}>
                              {user.error}
                            </Tooltip>
                          }
                        >
                          <Icon
                            css={{
                              color: "$warningLight !important",
                              cursor: "pointer",
                            }}
                            icon="triangle-exclamation"
                          />
                        </OverlayTrigger>
                      </Inline>
                    </TD>
                  </TR>
                );
              })}
          </TBody>
        </Table>
      </div>
    );
  }
);

export default ViewFailedItem;
